module.exports = __webpack_public_path__ + "img/logoAgenda.c538317a.png";